// extracted by mini-css-extract-plugin
module.exports = {"listDiv":"ChangePassword_listDiv_1tBdH","changePasswordText":"ChangePassword_changePasswordText_FYjUV"};